import { cssTheme } from '@uds/theme-utils';
import { css } from 'linaria';

export default () => {
  return {
    category: css`
      display: flex;
      align-items: center;
      color: ${cssTheme.palette.grey02};
      margin-bottom: ${cssTheme.gu1};
    `,
    title: css`
      color: ${cssTheme.palette.grey02};
    `,
    body: css`
      margin-top: ${cssTheme.gu2};
      flex-grow: 1;
      color: ${cssTheme.palette.grey04};
    `,
  };
};
